type NonNull<Type> = {
  [Property in keyof Type]: NonNullable<Type[Property]>
}

const dev = {
  API_URL: 'https://dev-api.brick.tech',
}

const prod = {
  API_URL: 'https://api.brick.tech',
}

const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV

export const getOrigin = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  if (VERCEL_ENV === 'preview' || VERCEL_ENV === 'development') {
    return 'https://www.brick-dev.tech'
  }
  if (VERCEL_ENV === 'production') {
    return 'https://www.brick.tech'
  }
  return 'http://localhost:3000'
}

const env = {
  INTERCOM_APP_ID: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
  X_API_KEY: process.env.NEXT_PUBLIC_BRICK_X_API_KEY,
  GTM_CONTAINER_ID: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID,
  USE_PHRASE: process.env.NEXT_PUBLIC_USE_PHRASE ?? 'false',
  GOOGLE_MAPS_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
  COOKIEYES_ID: process.env.NEXT_PUBLIC_COOKIEYES_ID,
  VERCEL_ENV: VERCEL_ENV ?? 'development',
  BASE_URL: getOrigin(),
  ...(process.env.VERCEL_ENV === 'production' ? prod : dev),
} as const

type NonNullEnv = NonNull<typeof env>

const missingVars = Object.entries(env).filter(([_key, val]) => val == null)

if (missingVars.length > 0) {
  const error = `missing environmental variables:\n${missingVars
    .map(([key]) => key)
    .join('\n')}`
  throw new Error(error)
}

export default env as NonNullEnv
